import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.min.css';

import Message from 'components/common-sfims/modal/Message';
import Layout from 'layouts/Layout';

const App = () => (
  <>
    <Message />
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Layout />
    </BrowserRouter>
  </>
);

export default App;
